/**
 * Converts a Google Maps place/search URL to an embeddable iframe src.
 *
 * Handles:
 *  - Already-embed URLs (maps/embed?...) → returned as-is
 *  - Place URLs with @lat,lng  → extracts coordinates for embed
 *  - Fallback                  → uses the free iframe embed format with the location name
 */
export function toEmbedUrl(url, fallbackName = '') {
  if (!url && !fallbackName) return null;

  // Already an embed URL
  if (url && url.includes('/maps/embed')) return url;

  let query = fallbackName;

  if (url) {
    try {
      const parsed = new URL(url);

      // Extract coordinates from path like /@18.6251174,73.8188033,...
      const coordMatch = parsed.pathname.match(/@(-?\d+\.\d+),(-?\d+\.\d+)/);
      if (coordMatch) {
        const lat = coordMatch[1];
        const lng = coordMatch[2];
        return `https://maps.google.com/maps?q=${lat},${lng}&hl=fr&z=14&output=embed`;
      }

      // Extract place name from path like /maps/place/St.+Anthony's+Church/
      const placeMatch = parsed.pathname.match(/\/maps\/place\/([^/]+)/);
      if (placeMatch) {
        query = decodeURIComponent(placeMatch[1].replace(/\+/g, ' '));
      } else if (parsed.searchParams.has('q')) {
        query = parsed.searchParams.get('q');
      }
    } catch {
      // Ignored, fallback to name
    }
  }

  if (query) {
    return `https://maps.google.com/maps?q=${encodeURIComponent(query)}&hl=fr&z=14&output=embed`;
  }

  return null;
}
